export const ACCOUNT_CREATED = 'accountCreated';
export const CONTACT_CREATED = 'contactCreated';
export const CONTACT_NOTE_CREATED = 'contactNoteCreated';
export const QUOTE_CREATED = 'quoteCreated';
export const QUOTE_NOTE_CREATED = 'quoteNoteCreated';
